
import React from 'react'
import styled from 'styled-components'
import { PageType } from '../../interfaces/types'
import iconBg from './iconBg.svg'

import handshake from './handshake.png'
import leaf from './leaf.png'
import shield from './shield.png'

const StyledCard = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  padding: 1em;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  width: 90%;
  gap: 15px;

  h1 {
    font-size: 1.4em;
    font-weight: 800;
    margin: 0;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .tag-container {
    margin-bottom: 0.5em;
  }

  .tag {
    font-size: 1em;
    background-color: #EEEEEE;
    padding: 0.1em 1em;
    text-align: center;
  }

`


const ManifestoCard = (props: {
  setCurrentPage: (page: PageType, path?: string) => void,
  data: {
    img: 'shield' | 'handshake' | 'leaf',
    title: string,
    tags: string[],
  }
}) => {
  return (
    <StyledCard
      onClick={() => {
        props.setCurrentPage('MANIFESTO', props.data.title)
      }}
    >
      <div
        style={{
          position: 'relative',
        }}
      >
        <img src={iconBg} alt="산책도시를 위한 공약 리스트"
        // make img as background
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
        />
        <img
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translateY(-50%) translateX(-50%)',
          height: '45%',
        }}
        src={{
          handshake,
          leaf,
          shield
          }[props.data.img]} alt="산책도시를 위한 공약 리스트" />
      </div>
      <div className='tag-container'>
        <h1>{props.data.title}</h1>
        #{props.data.tags[0]+' '} 
        #{props.data.tags[1]+' '} <br/>
        #{props.data.tags[2]+' '} 
        #{props.data.tags[3]}
        </div>
    </StyledCard>
  )
}

export default ManifestoCard